module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-port clearfix quickview-notes",
    attrs: {
      "id": "note-views"
    }
  }, [_c('div', {
    staticClass: "view list",
    attrs: {
      "id": "quick-note-list"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('ul', _vm._l((_vm.notes), function(note) {
    return _c('Note', {
      key: note.id,
      attrs: {
        "note": note
      }
    })
  }))]), _vm._v(" "), _c('NoteEditor')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar clearfix"
  }, [_c('ul', {
    staticClass: "pull-right "
  }, [_c('li', [_c('a', {
    staticClass: "delete-note-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "new-note-link",
    attrs: {
      "href": "#",
      "data-navigate": "view",
      "data-view-port": "#note-views",
      "data-view-animation": "push"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-remove-notes btn btn-xs btn-block hide"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2232eb0e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/notes.vue
// module id = 1306
// module chunks = 1